import { Card, CardSearch, ExportData, PageBodyHeader, ReportStoreModal, Table } from "../../component";
import { useEffect, useState } from "react";
import { UrlTypes, generalObj } from "../../constant/object_types";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { fetchOrganizationList, fetchStoreGeneralListReport, fetchStoreListByUserId, fetchStoreListReport } from "../../action/generalFunc";
import { toast } from "react-toastify";

const VendorStoreList = () => {
    const navigate = useNavigate();
    const [storeList, setStoreList] = useState<generalObj[]>([]);
    const [organizationList, setOrganizationList] = useState<generalObj[]>([{
        label: 'All',
        value: 'All'
    }]);
    const [searchText, setSearchText] = useState<string>("");
    const [openReportModal, setOpenReportModal] = useState<boolean>(false);
    const [exportType, setExportType] = useState<string | null>(null);

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
     
    useEffect(() => {
        if (!account || !account.isAuthenticated ) return;
        (async () => {
            let result = await fetchStoreListByUserId(account.token, account.id, "vendor");
            if (result) {
                setStoreList(result.data.stores);
                let org_result = await fetchOrganizationList(account.token);
                if (org_result) {
                    let org_list:generalObj[] = [];
                    org_result.data.organization.forEach((element:generalObj) => {
                        org_list.push({
                            "id": element.id,
                            "label": element.name,
                            "value": element.name
                        })
                    })
                    setOrganizationList([{
                        label: 'All',
                        value: 'All'
                    }, ...org_list]);
                }
            }
            setModalLoading(false);
        })();
    }, [account, setModalLoading]);

    const onSearch = (val:string) => {
        setStoreList((prevStoreList) => {
            return (
                prevStoreList.filter((item) => {
                    if (item.name.toLowerCase().includes(val.toLowerCase()) || item.organization.toLowerCase().includes(val.toLowerCase())) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    const processExport = (export_type:string) => {
        generateReport(export_type)
    }
    const processGenExport = (export_type:string) => {
        setExportType(export_type);
        setOpenReportModal(true);
    }

    const generateReport = async (exportType:String) => {
        if (!exportType || !account || !account.isAuthenticated) return;

        setModalLoading(true);
        let param = {
            type: exportType,
        };
        
        let result = await fetchStoreListReport(account.token, param);

        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `store_list.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            toast("Report generated");
        }
        setModalLoading(false);
    }

    const generateGenReport = async (val:generalObj) => {
        if (!exportType || !account || !account.isAuthenticated) return;

        setModalLoading(true);
        let date_from_obj = new Date(val.date_from);
        let date_to_obj = new Date(val.date_to);
        let param:generalObj = {
            type: exportType,
            date_from: date_from_obj.toISOString(),
            date_to: date_to_obj.toISOString(),
            organization: val.organization.label
        };

        let result = await fetchStoreGeneralListReport(account.token, param);
        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `store_performance_list.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            setExportType(null);
            setOpenReportModal(false);
            toast("Report generated");
        }
        setModalLoading(false);
    }


    return (
        <>
            <PageBodyHeader title="Store List" desc="Check list of available Stores" />
            
            <div style={{marginBottom:"24px"}}> 
                <Card title="Store Performance Report" style={{height:"100%"}}>
                    <div style={{position:"absolute", top:"50%", right:"20px", transform: "translateY(-50%)"}}>
                        <ExportData export_type={(val) => processGenExport(val)} />
                    </div>
                </Card>
            </div>

            <Table table_head={["#", "Organization", "Store", "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            tableAction={<ExportData export_type={(val) => processExport(val)} />}
            headerStyle={{marginBottom: "44px"}}
            >
                <>
                    {storeList.map((item, index) => (
                        (item.show || item.show === undefined) && (
                            <tr key={index}>
                                <td>
                                    {index+1}
                                </td>
                                <td>{item.organization}</td>
                                <td>{item.name}</td>
                                <td>
                                    <button onClick={() => navigate(`${UrlTypes.VENDOR_MENU}${item.id}/`)} className={`status__container completed`} style={{width:"60px", padding:"5px"}}>View</button>
                                </td>
                            </tr>
                        )
                    ))}
                </>
            </Table>

            <ReportStoreModal visible={openReportModal} organizationList={organizationList} modalClose={() => setOpenReportModal(false)} onAdded={(val) => generateGenReport(val)}  />
        </>
    )
}

export default VendorStoreList